import Vue from 'vue'
import Router from 'vue-router'
import Index from '@/components/Index'
import CreateGame from '@/components/CreateGame'
import JoinGame from '@/components/JoinGame'
import Game from '@/components/Game'
import License from '@/components/License'
import VueClipboard from 'vue-clipboard2'
 
Vue.use(Router)
Vue.use(VueClipboard)

export default new Router({
  mode: 'history',
  routes: [
    {
      path: '/',
      name: 'CreateGame',
      component: CreateGame
    },
    {
      path: '/do-not-share/:gameCode/:playerCode',
      name: 'Game',
      component: Game
    },
    {
      path: '/join-game/:gameCode',
      name: 'JoinGame',
      component: JoinGame
    },
    {
      path: '/license',
      name: 'License',
      component: License
    },
    {
      path: "*",
      name: 'RedirectToCreateGame',
      component: CreateGame
    }
  ]
})



// WEBPACK FOOTER //
// ./src/router/index.js